// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const ToiletsWithHandWashFacilities = "toiletsWithHandWashFacilities";
const DrinkingFountainsOrTaps = "drinkingFountainsOrTaps";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const EcostatusHygieneEnum = {
    ...createEnum("EcostatusHygiene", [
        [ToiletsWithHandWashFacilities, "Toilets with hand-wash facilities"],
        [DrinkingFountainsOrTaps, "Drinking fountains / taps"],
    ]),
    ToiletsWithHandWashFacilities,
    DrinkingFountainsOrTaps,
};
null;
null;
export default EcostatusHygieneEnum;
//# sourceMappingURL=EcostatusHygieneEnum.generated.js.map